import ajax, {
  XHRTracker,
} from '@get-bridge/learn-legacy-shared/dist/utils/ajax';
import magnificentAjax from './magnificentAjax';
import { addCSRFHeaderToAPIRequests } from './AjaxExtensions';
import $ from '@get-bridge/learn-legacy-shared/dist/utils/jquery';
import Promise from 'Promise';

export default () => {
  const pendingRequestsMiddleware = XHRTracker(() => {});

  return {
    id: 'ajax',
    name: 'configure ajax global adapter',

    initialize(done) {
      ajax.__setGlobalMiddlewares__([pendingRequestsMiddleware]);
      ajax.__setAdapter__(magnificentAjax);
      ajax.__setPromise__(Promise);
      addCSRFHeaderToAPIRequests();
      $.ajaxPrefilter(function(outbound, upstream) {
        if (outbound.type.match(/post|put|patch|delete/i)) {
          outbound.contentType = "application/json";

          if (typeof upstream.data !== "string") {
            outbound.data = JSON.stringify(upstream.data);
          }
        }
      });
      done();
    },

    teardown(done) {
      const pendingRequests = pendingRequestsMiddleware.exports.getPendingRequests();

      pendingRequests.forEach(request => {
        request.abort();
      });

      done();
    },
  }
}



// WEBPACK FOOTER //
// ./jsapp/config/initializers/ajax.js